export default (state = () => { return null }, { type, payload }) => {
    switch (type) {
        case 'SET_HUNT_PLANNER_MAP_REFERENCE':
            return payload
        case 'SET_HUNT_PLANNER_MAP_REFERENCE_NULL':
            return null
        case 'LOGOUT':
            return () => { return null }
        default:
            return state
    }
}